import { Component } from 'react';
import PropTypes from 'prop-types';
// jl-design-system
import {
  SecondaryButton,
  PrimaryButton,
  UnderlinedButton,
} from 'jl-design-system/elements/button/Button';
import Link from 'jl-design-system/elements/link/Link';

import AddressWithSearchForm from 'jl-design-system/components/address-with-search-form/AddressWithSearchForm';
import { Message } from 'jl-design-system/components/message/Message';
import { resetAddressSearch } from 'jl-design-system/redux/actions/address/addressActions';
import replaceStringVars from 'jl-design-system/utils/string/replaceStringVars';

// redux
import { connect } from 'react-redux';
import {
  editDeliveryAddress,
  setDeliveryAddressAndGetDeliveryMethods,
  resetDeliveryAddressAndMethods,
  changeDeliveryAddress,
  setShowDeliveryAddressForm,
  onUseAddressButtonClick,
} from '../../redux/actions/delivery/deliveryActions';
import {
  updateAddress,
  createAddress,
} from '../../redux/actions/addressBook/addressBookActions';
import { showEditBasketModal } from '../../redux/actions/edit-basket/editBasketActions';
import {
  setScrollToDeliveryDetails,
} from '../../redux/actions/app/appActions';
import {
  onLoqateSearch,
  triggerLoqateTimeoutEnterAddressManuallyAnalytics,
  onLoqateNetworkTimeoutCallback,
  onEnterManualAddress,
} from '../../redux/actions/address/addressActions';
import {
  saveForLaterAvailableForUndeliverableServiceParent,
} from '../../redux/reducers/delivery/deliveryContainsUndeliverableServices';
import { itemsContainM2M } from '../../utils/orderform/isItemFabric';
import { isFeatureActive } from '../../redux/reducers/config/configReducer';


// config
import routeConstants from '../../constants/routeConstants';
import { DELIVERY_ADDRESS } from '../../constants/actionConstants';
import deliveryConstants from '../../constants/deliveryConstants';
import {
  getDeliveryAddressFormConfig,
  DELIVERY_ADDRESS_FORM_ID,
} from '../../utils/form/configs/deliveryAddress';
import featureConstants from '../../constants/featureConstants';

// utils
import { shouldMockLoqate } from '../../utils/address/addressHelpers';
import getLoqateMocks from '../../non-prod-utils/utils/loqate/getLoqateMocks';
import errorMessageBodyLookup from '../../utils/error/errorMessageBodyLookup';
// components
import AddressBookCarousel from '../delivery-address-carousel';
import AddressBookModal from '../address-book-modal';
import BodyText from '@components/body-text';
import Container from '../container';
import DeliveryAddressCard from '../delivery-address-card/DeliveryAddressCard';
import DisplayAddress from '../display-address/DisplayAddress';
import Heading from '../heading';
import InvalidAddressForm from '../invalid-address-form/InvalidAddressForm';
import UndeliverableServicesError from '../undeliverable-services-error';
import UndeliverableErrorMessage, { getUndeliverableErrorMessage } from '../undeliverable-error-message/UndeliverableErrorMessage';
import UserEmailAddress from '../user-email-address';
// styles
import styles from './delivery-address.scss';

export class DeliveryAddress extends Component {

  static propTypes = {
    addressBook: PropTypes.arrayOf(PropTypes.shape({
      address: PropTypes.shape({
        address1: PropTypes.string,
        address2: PropTypes.string,
        address3: PropTypes.string,
        address4: PropTypes.string,
        countryCode: PropTypes.string,
        countyStateOrProvince: PropTypes.string,
        postcode: PropTypes.string,
        town: PropTypes.string,
      }),
      addressee: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        title: PropTypes.string,
      }),
      phoneNumber: PropTypes.string,
    })),
    addressSearchComplete: PropTypes.bool,
    canUseSelectedDeliveryAddress: PropTypes.bool,
    changeDeliveryAddress: PropTypes.func,
    changingAddress: PropTypes.bool,
    confirmedDeliveryAddress: PropTypes.shape({
      address: PropTypes.shape({}),
      addressee: PropTypes.shape({}),
      id: PropTypes.string,
      phoneNumber: PropTypes.string,
    }),
    countryCode: PropTypes.string,
    createAddress: PropTypes.func,
    deliveries: PropTypes.arrayOf(PropTypes.object),
    deliveryContainsIncompatibleServices: PropTypes.bool,
    deliveryContainsUndeliverableServices: PropTypes.bool,
    disabled: PropTypes.bool,
    editDeliveryAddress: PropTypes.func,
    headingTag: PropTypes.string,
    incompleteDeliveryDetailsError: PropTypes.shape({
      body: PropTypes.string,
      code: PropTypes.string,
      message: PropTypes.string,
      refreshes: PropTypes.number,
    }),
    isLoadingLazyComponent: PropTypes.bool,
    isNewAddressLayout: PropTypes.bool,
    isSignedIn: PropTypes.bool,
    isSignedInWithData: PropTypes.bool,
    items: PropTypes.arrayOf(PropTypes.object),
    loqateApiKey: PropTypes.string,
    onEnterManualAddress: PropTypes.func,
    onLoqateNetworkTimeoutCallback: PropTypes.func,
    onLoqateSearch: PropTypes.func,
    onUseAddressButtonClick: PropTypes.func,
    pathname: PropTypes.string,
    postcodeOutOfAreaError: PropTypes.shape({
      body: PropTypes.string,
      code: PropTypes.string,
      message: PropTypes.string,
    }),
    putDeliveryAddressError: PropTypes.shape({
      body: PropTypes.string,
      bodyLookup: PropTypes.string,
      message: PropTypes.string,
    }),
    resetDeliveryAddressAndMethods: PropTypes.func,
    saveAddressError: PropTypes.shape({
      body: PropTypes.string,
      message: PropTypes.string,
    }),
    saveForLaterAvailableOnUndeliverableServiceParent: PropTypes.bool,
    selectedDeliveryAddress: PropTypes.shape({
      address: PropTypes.shape({
        postcode: PropTypes.string,
      }),
      addressee: PropTypes.shape({}),
      id: PropTypes.string,
      invalid: PropTypes.bool,
      phoneNumber: PropTypes.string,
    }),
    servicesThatNeedRemoving: PropTypes.arrayOf(PropTypes.shape({})),
    sessionId: PropTypes.string,
    setDeliveryAddressAndGetDeliveryMethods: PropTypes.func,
    setScrollToDeliveryDetails: PropTypes.func,
    shouldReFetchDeliveryOptions: PropTypes.bool,
    showAddressBookModal: PropTypes.bool,
    showEditBasketModal: PropTypes.func,
    triggerLoqateTimeoutEnterAddressManuallyAnalytics: PropTypes.func,
    undeliverableItemsInBasket: PropTypes.arrayOf(PropTypes.object),
    updateAddress: PropTypes.func,
    useThisAddressButtonSubmitting: PropTypes.bool,
    userEmailAddress: PropTypes.string,
  };

  static defaultProps = {
    addressBook: [],
    addressSearchComplete: false,
    canUseSelectedDeliveryAddress: true,
    changeDeliveryAddress: window.defaultFunc,
    changingAddress: false,
    confirmedDeliveryAddress: undefined,
    countryCode: '',
    createAddress: window.defaultFunc,
    deliveries: [],
    deliveryContainsIncompatibleServices: false,
    deliveryContainsUndeliverableServices: false,
    disabled: false,
    editDeliveryAddress: window.defaultFunc,
    headingTag: 'h3',
    incompleteDeliveryDetailsError: undefined,
    isLoadingLazyComponent: false,
    isNewAddressLayout: false,
    isSignedIn: false,
    isSignedInWithData: false,
    items: [],
    loqateApiKey: '',
    onEnterManualAddress: window.defaultFunc,
    onLoqateNetworkTimeoutCallback: window.defaultFunc,
    onLoqateSearch: window.defaultFunc,
    onUseAddressButtonClick: window.defaultFunc,
    pathname: '',
    postcodeOutOfAreaError: undefined,
    resetAddressSearch: window.defaultFunc,
    resetDeliveryAddressAndMethods: window.defaultFunc,
    saveAddressError: undefined,
    saveForLaterAvailableOnUndeliverableServiceParent: false,
    selectedDeliveryAddress: undefined,
    servicesThatNeedRemoving: undefined,
    sessionId: undefined,
    setDeliveryAddressAndGetDeliveryMethods: window.defaultFunc,
    setScrollToDeliveryDetails: window.defaultFunc,
    shouldReFetchDeliveryOptions: false,
    showAddressBookModal: false,
    showEditBasketModal: window.defaultFunc,
    triggerLoqateTimeoutEnterAddressManuallyAnalytics: window.defaultFunc,
    undeliverableItemsInBasket: [],
    updateAddress: window.defaultFunc,
    useThisAddressButtonSubmitting: false,
    userEmailAddress: '',
  };

  constructor() {
    super();
    this.state = {
      isChoosingAddress: false,
    };
  }

  componentDidUpdate(prevProps) {
    const {
      addressSearchComplete,
      shouldReFetchDeliveryOptions,
      setDeliveryAddressAndGetDeliveryMethods,
      setScrollToDeliveryDetails,
      selectedDeliveryAddress,
    } = this.props;

    const hasAddressSearchCompleted = (
      !prevProps.addressSearchComplete && addressSearchComplete
    );

    if (hasAddressSearchCompleted) {
      return;
    }

    const shouldSetDeliveryAddressAndGetDeliveryMethods = (
      selectedDeliveryAddress &&
      (!prevProps.shouldReFetchDeliveryOptions && shouldReFetchDeliveryOptions)
    );
    if (shouldSetDeliveryAddressAndGetDeliveryMethods) {
      setScrollToDeliveryDetails(true);
      setDeliveryAddressAndGetDeliveryMethods({
        address: selectedDeliveryAddress,
      });
    }
  }

  onSearchForAnotherAddress = ({ addressId }) => {
    const { resetDeliveryAddressAndMethods, countryCode } = this.props;
    resetDeliveryAddressAndMethods({ addressId, countryCode });
  };

  onChangeAddressClick = () => {
    const { changeDeliveryAddress, isNewAddressLayout } = this.props;

    this.setState({ isChoosingAddress: true });
    if (isNewAddressLayout) {
      return;
    }
    changeDeliveryAddress();
  };

  toggleAddNewAddressForm = (value) => {
    this.setState({ isChoosingAddress: value });
  };

  onEditAddressClick = () => {
    const {
      editDeliveryAddress,
      selectedDeliveryAddress,
    } = this.props;

    editDeliveryAddress(selectedDeliveryAddress);
  };

  isMultiBatch = () => {
    const {
      deliveries,
    } = this.props;

    return deliveries.length > 1;
  };

  getUndeliverableServices = () => {
    const {
      deliveries,
    } = this.props;

    const undeliverableServices = deliveries.reduce((acc, delivery) => {
      if (delivery.undeliverableServices) {
        return [...acc, ...delivery.undeliverableServices.items];
      }
      return acc;
    }, []);

    return undeliverableServices;
  };

  renderEmail = margin => <UserEmailAddress isMarginApplied={margin} />;

  editBasket = () => {
    const {
      showEditBasketModal,
      pathname,
    } = this.props;

    showEditBasketModal({ baseRoutePath: pathname });
  };

  render() {

    const {
      addressBook,
      canUseSelectedDeliveryAddress,
      changingAddress,
      confirmedDeliveryAddress,
      createAddress,
      deliveryContainsUndeliverableServices,
      disabled,
      headingTag,
      incompleteDeliveryDetailsError,
      isLoadingLazyComponent,
      isNewAddressLayout,
      isSignedInWithData,
      items,
      loqateApiKey,
      onEnterManualAddress,
      onLoqateNetworkTimeoutCallback,
      onLoqateSearch,
      postcodeOutOfAreaError,
      servicesThatNeedRemoving,
      saveAddressError,
      selectedDeliveryAddress,
      showAddressBookModal,
      triggerLoqateTimeoutEnterAddressManuallyAnalytics,
      undeliverableItemsInBasket,
      updateAddress,
      sessionId,
      deliveryContainsIncompatibleServices,
      onUseAddressButtonClick,
      useThisAddressButtonSubmitting,
      putDeliveryAddressError,
      saveForLaterAvailableOnUndeliverableServiceParent,
      userEmailAddress,
    } = this.props;

    const { isChoosingAddress } = this.state;

    const addressId = DELIVERY_ADDRESS;

    const configExtras = {
      styles,
    };

    const footerText = deliveryContainsIncompatibleServices ? (
      <>
        <p>
          Please <Link to={routeConstants.EDIT_BASKET}>edit your basket</Link> and remove a service.
          {
            saveForLaterAvailableOnUndeliverableServiceParent &&
            <> Or you can select ‘save for later’ to continue in 2 separate orders.</>
          }
          {
            !saveForLaterAvailableOnUndeliverableServiceParent &&
            <> Or you can remove an item to continue in 2 separate orders.</>
          }
        </p>
      </>
    ) : (
      <p>
        To continue, please{' '}
        <UnderlinedButton onClick={this.onChangeAddressClick}>choose a different delivery address</UnderlinedButton>,
        or <Link to={routeConstants.EDIT_BASKET}>edit your basket</Link> to remove the service.
      </p>
    );

    const deliveryRemovedServiceItems = servicesThatNeedRemoving && servicesThatNeedRemoving.length ? (
      <>
        <ul className={styles.removedServicesList}>
          {
            servicesThatNeedRemoving.map((item, index) => {
              const key = `rangeTimes-${index}`;
              return (
                <li key={`removedService-${key}`}>{`${item.name} - For ${item.productName}`}</li>
              );
            })
          }
        </ul>

        {footerText}
      </>
    ) : undefined;

    const invalidAddressMessageBody = isSignedInWithData ?
      'Some of the information in your default delivery address is missing or invalid. Please update this information or change the address to continue.' :
      '';

    if (incompleteDeliveryDetailsError && confirmedDeliveryAddress) {
      incompleteDeliveryDetailsError.body = 'Please select the ‘Continue to payment’ button to proceed.';
    }

    const undeliverableItemsMessage = getUndeliverableErrorMessage({
      items,
      editBasket: this.editBasket,
      onChangeAddressClick: this.onChangeAddressClick,
      undeliverableItemsInBasket,
    });
    const isMultiBatch = this.isMultiBatch();
    const undeliverableServices = this.getUndeliverableServices();
    const deliveryHeading = isNewAddressLayout ?
      isChoosingAddress ?
        'Choose delivery address'
        : 'Your preferred delivery details'
      : 'Delivery details';

    const saveSelectedDeliveryAddressAsDefaultProps = canUseSelectedDeliveryAddress ? {
      saveAsDefaultObject: selectedDeliveryAddress,
      saveAsDefaultType: deliveryConstants.DELIVERY,
    } : undefined;

    return (
      <Container
        background="white"
        className={styles.container}
        marginBottom="0"
        padding="3"
      >
        {
          (!isMultiBatch && deliveryContainsUndeliverableServices) &&
          <UndeliverableServicesError items={undeliverableServices} />
        }

        <Heading
          label={deliveryHeading}
          marginBottom="3"
          tag={headingTag}
          testId="delivery-title"
          type="s"
        />
        <>
          {postcodeOutOfAreaError && (
            <Container marginBottom="2">
              <Message
                body={errorMessageBodyLookup({
                  body: postcodeOutOfAreaError.body,
                  bodyLookup: postcodeOutOfAreaError.code,
                })}
                dataTestId="delivery-address-postcode-out-of-area-error"
                title={replaceStringVars(postcodeOutOfAreaError.message, {
                  postcode: selectedDeliveryAddress?.address?.postcode ?? '',
                })}
                type="error"
              />
            </Container>
          )}
          {incompleteDeliveryDetailsError && (
            <Container marginBottom="2">
              <Message
                body={incompleteDeliveryDetailsError.body}
                dataTestId="delivery-address-incomplete-details-error"
                title={incompleteDeliveryDetailsError.message}
                type="error"
              />
            </Container>
          )}
          {Array.isArray(servicesThatNeedRemoving) && servicesThatNeedRemoving.length > 0 && (
            <Container marginBottom="2">
              <Message
                body={deliveryRemovedServiceItems || 'Your basket has been updated to reflect this.'}
                dataId="delivery-removed-service-message"
                dataTestId="delivery-removed-service-message"
                scrollToMessageOnMount
                title={deliveryContainsIncompatibleServices ? 'Sorry, the following services cannot be purchased together' : 'Sorry, one or more services in your order are unavailable'}
                type="error"
              />
            </Container>
          )}
          {
            undeliverableItemsMessage?.length && !changingAddress &&
            undeliverableItemsMessage.map((message, ind) => (
              <UndeliverableErrorMessage
                key={`message-${ind + 1}`}
                undeliverableItemsMessage={message}
              />
            ))
          }
          {putDeliveryAddressError && !postcodeOutOfAreaError && (
            <Container marginBottom="2">
              <Message
                body={errorMessageBodyLookup({
                  bodyLookup: putDeliveryAddressError.bodyLookup,
                  body: putDeliveryAddressError.body,
                })}
                title={putDeliveryAddressError.message}
                type="error"
              />
            </Container>
          )}
        </>
        {!selectedDeliveryAddress && !isNewAddressLayout && this.renderEmail(true)}
        {isNewAddressLayout &&
          <Container>
            <Heading type="xs">Account Email</Heading>
            <BodyText marginBottom='1'>{userEmailAddress}</BodyText>
            {isChoosingAddress &&
              <AddressBookCarousel
                addressBook={addressBook}
                configExtras={configExtras}
                formId={DELIVERY_ADDRESS_FORM_ID}
                getConfig={getDeliveryAddressFormConfig}
                toggleAddNewAddressForm={this.toggleAddNewAddressForm}
              />}
          </Container>}

        {
          !selectedDeliveryAddress && !confirmedDeliveryAddress &&
          <>
            <AddressWithSearchForm
              addressId={addressId}
              combineExtraAddressLines
              configExtras={configExtras}
              data-testid="delivery-address-form"
              destroyOnUnmount={false}
              formId={DELIVERY_ADDRESS_FORM_ID}
              getConfig={getDeliveryAddressFormConfig}
              getLoqateMocks={getLoqateMocks}
              jlpid={sessionId}
              loqateApiKey={loqateApiKey}
              maxAddressLines={3}
              multiFormValidation
              onAddressFormSubmit={onUseAddressButtonClick}
              onEnterManualAddress={onEnterManualAddress}
              onLoqateNetworkTimeoutCallback={onLoqateNetworkTimeoutCallback}
              onLoqateSearch={onLoqateSearch}
              onLoqateTimeoutEnterAddressManuallyCallback={triggerLoqateTimeoutEnterAddressManuallyAnalytics}
              onSearchForAnotherAddressOverride={this.onSearchForAnotherAddress}
              replaceGbTerritoryCountryCodes={false}
              shouldMockLoqate={shouldMockLoqate()}
              useLoqateAddressSearch
            />
          </>
        }

        {
          selectedDeliveryAddress && !confirmedDeliveryAddress &&
          <>
            {
              (
                selectedDeliveryAddress.invalid &&
                !showAddressBookModal
              ) &&
              <InvalidAddressForm
                addressBook={addressBook}
                addressFormId={DELIVERY_ADDRESS_FORM_ID}
                configExtras={configExtras}
                getConfig={getDeliveryAddressFormConfig}
                maxAddressLines={3}
                messageBody={invalidAddressMessageBody}
                onChangeAddress={this.onChangeAddressClick}
                onCreateAddress={createAddress}
                onUpdateAddress={updateAddress}
                savedAddress={selectedDeliveryAddress}
                showChangeAddressButton={isSignedInWithData}
              />
            }

            {
              !selectedDeliveryAddress.invalid &&

              <>
                {isNewAddressLayout ?
                  <DeliveryAddressCard
                    address={selectedDeliveryAddress.address}
                    addressId={selectedDeliveryAddress.id}
                    addressee={selectedDeliveryAddress.addressee}
                    handleChangeAddressClick={this.onEditAddressClick}
                    phoneNumber={selectedDeliveryAddress.phoneNumber}
                  />
                  :
                  <>
                    <DisplayAddress
                      address={selectedDeliveryAddress.address}
                      addressee={selectedDeliveryAddress.addressee}
                      data-testid="delivery-address-selected"
                      phoneNumber={selectedDeliveryAddress.phoneNumber}
                      saveAddressError={saveAddressError}
                      {...saveSelectedDeliveryAddressAsDefaultProps}
                    />

                    {
                      !canUseSelectedDeliveryAddress && !isNewAddressLayout &&
                      <div className={styles.buttonsContainer}>
                        <PrimaryButton
                          className={styles.changeAddressButton}
                          data-testid="delivery-address-change-button"
                          disabled={disabled}
                          onClick={this.onChangeAddressClick}
                          submitting={isLoadingLazyComponent}
                        >
                          Change address
                        </PrimaryButton>
                      </div>
                    }
                  </>}
                {
                  canUseSelectedDeliveryAddress &&
                  <>
                    {
                      // address editing for customer with address book takes place in address book modal
                      !isSignedInWithData &&
                      <UnderlinedButton
                        className={styles.editAddressButton}
                        data-testid="delivery-address-edit-address"
                        disabled={disabled}
                        onClick={this.onEditAddressClick}
                      >
                        Edit address
                      </UnderlinedButton>
                    }

                    {this.renderEmail()}

                    <div className={styles.buttonsContainer}>
                      <PrimaryButton
                        className={styles.useAddressButton}
                        data-testid="delivery-address-use-address"
                        disabled={disabled}
                        onClick={() => onUseAddressButtonClick()}
                        submitting={useThisAddressButtonSubmitting}
                      >
                        Use this address
                      </PrimaryButton>
                    </div>
                  </>
                }
              </>

            }

          </>

        }

        {
          confirmedDeliveryAddress &&
          <>
            {saveAddressError && (
              <Container marginBottom="2">
                <Message
                  body={saveAddressError.body}
                  dataTestId="save-address-failed-message"
                  title={saveAddressError.message}
                  type="information"
                />
              </Container>
            )}

            {isNewAddressLayout ? (
              <Container>
                {!isChoosingAddress && (
                  <DeliveryAddressCard
                    address={confirmedDeliveryAddress.address}
                    addressId={confirmedDeliveryAddress.id}
                    addressee={confirmedDeliveryAddress.addressee}
                    handleChangeAddressClick={this.onChangeAddressClick}
                    phoneNumber={confirmedDeliveryAddress.phoneNumber}
                  />
                )}
              </Container>
            ) : (
              <div className={styles.deliveryAddressWrapper}>
                <DisplayAddress
                  address={confirmedDeliveryAddress.address}
                  addressee={confirmedDeliveryAddress.addressee}
                  data-testid="delivery-address-confirmed"
                  isUndeliverableAddress={!!undeliverableItemsMessage?.length}
                  phoneNumber={confirmedDeliveryAddress.phoneNumber}
                  saveAddressError={saveAddressError}
                  saveAsDefaultObject={confirmedDeliveryAddress}
                  saveAsDefaultType={deliveryConstants.DELIVERY}
                />
              </div>
            )}

            {!isNewAddressLayout && this.renderEmail()}

            {
              !isNewAddressLayout && undeliverableItemsInBasket.length === 0 &&
              <SecondaryButton
                className={styles.changeAddressButton}
                data-testid="delivery-address-change-button"
                disabled={disabled}
                onClick={this.onChangeAddressClick}
                submitting={isLoadingLazyComponent}
              >
                Change address
              </SecondaryButton>
            }

            {
              !isNewAddressLayout && undeliverableItemsInBasket.length > 0 &&
              <div className={styles.undeliverableItemsActions}>
                <PrimaryButton
                  data-testid="delivery-address-change-button-primary"
                  onClick={this.onChangeAddressClick}
                  submitting={isLoadingLazyComponent}
                >
                  Change address
                </PrimaryButton>
                {
                  undeliverableItemsInBasket.length !== items.length &&
                  <SecondaryButton
                    onClick={this.editBasket}
                  >
                    Edit basket
                  </SecondaryButton>
                }
              </div>
            }

          </>
        }

        {
          showAddressBookModal &&
          <AddressBookModal
            addressBook={addressBook}
            baseRoutePath={routeConstants.DELIVERY}
            configExtras={configExtras}
            formId={DELIVERY_ADDRESS_FORM_ID}
            getConfig={getDeliveryAddressFormConfig}
            isDelivery
          />
        }

      </Container>
    );
  }
}

export function mapStateToProps(state, ownProps) {
  const addressId = 'deliveryAddress';
  const deliveryAddressFormValues = state.form?.[DELIVERY_ADDRESS_FORM_ID]?.values ?? {};

  const { countryCode } = deliveryAddressFormValues;

  const putDeliveryAddressApiCallActive = state.delivery.putDeliveryAddressApiCallActive;
  const servicesThatNeedRemoving = state.delivery?.servicesThatNeedRemoving;
  const isSignedIn = state.user?.isSignedIn;

  const saveForLaterAvailableOnUndeliverableServiceParent = saveForLaterAvailableForUndeliverableServiceParent({
    servicesThatNeedRemoving,
    deliveries: state.delivery?.deliveries,
    isSignedIn,
    isExpressCheckout: state.app?.isExpressCheckout,
    isM2M: itemsContainM2M(state.orderForm?.items),
    isShipFromStore: state.orderForm?.items?.some(item => item?.availability?.shipFromStore),
  });

  return {
    pathname: state.router.location.pathname,
    countryCode: countryCode || '',
    deliveries: state.delivery.deliveries,
    addressSearchComplete: state[addressId].addressSearchComplete,
    showAddressBookModal: state.delivery.showAddressBookModal,
    addressBook: state.user.addressBook,
    incompleteDeliveryDetailsError: state.delivery.incompleteDeliveryDetailsError,
    selectedDeliveryAddress: state.user.selectedDeliveryAddress,
    confirmedDeliveryAddress: state.delivery.confirmedDeliveryAddress,
    canUseSelectedDeliveryAddress: state.user.canUseSelectedDeliveryAddress,
    saveAddressError: state.delivery.saveAddressError,
    servicesThatNeedRemoving,
    undeliverableItemsInBasket: state.delivery.undeliverableItemsInBasket,
    isLoadingLazyComponent: state.app?.loadingLazyComponent === 'AddressBookModal',
    isSignedInWithData: state.user.isSignedInWithData,
    disabled: (
      ownProps.disabled ||
      putDeliveryAddressApiCallActive ||
      (state.delivery.deliveries?.some(delivery => delivery.getDeliveryMethodsApiCallActive) ?? false) ||
      state.delivery.proceedingToPayment
    ),
    postcodeOutOfAreaError: state.user.postcodeOutOfAreaError,
    shouldReFetchDeliveryOptions: state.delivery.shouldReFetchDeliveryOptions,
    items: state.orderForm.items,
    loqateApiKey: state.config?.frontendKeys?.loqateApiKey,
    sessionId: state.bff.sessionId,
    deliveryContainsIncompatibleServices: state.delivery.deliveryContainsIncompatibleServices,
    deliveryContainsUndeliverableServices: state.delivery?.deliveryContainsUndeliverableServices,
    changingAddress: state.delivery.changingAddress,
    isSignedIn,
    useThisAddressButtonSubmitting: !!(state.delivery.createAddressAPICallActive ||
      state.addressBook.getAddressBookAPICallActive ||
      putDeliveryAddressApiCallActive),
    putDeliveryAddressError: state.delivery.putDeliveryAddressError,
    saveForLaterAvailableOnUndeliverableServiceParent,
    isNewAddressLayout: isFeatureActive(state, featureConstants.NEW_ADDRESS_BOOK_LAYOUT) && isSignedIn,
    userEmailAddress: state.user.email,
  };
}

export function mapDispatchToProps() {
  return {
    setDeliveryAddressAndGetDeliveryMethods,
    resetDeliveryAddressAndMethods,
    changeDeliveryAddress,
    createAddress,
    setShowDeliveryAddressForm,
    showEditBasketModal,
    updateAddress,
    editDeliveryAddress,
    setScrollToDeliveryDetails,
    resetAddressSearch,
    onLoqateSearch,
    triggerLoqateTimeoutEnterAddressManuallyAnalytics,
    onLoqateNetworkTimeoutCallback,
    onEnterManualAddress,
    onUseAddressButtonClick,
  };
}

export default connect((state, ownProps) => mapStateToProps(state, ownProps),
  mapDispatchToProps())(DeliveryAddress);
